import React, { useContext, useEffect } from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { PublicRoutes } from "./PublicRoutes";
import { PrivateRoutes } from "./PrivateRoutes";
import { AuthContext } from "../auth/AuthContext";
import { AuthRoutes } from "./AuthRoutes";
import { AllRoutes } from "./index";
import { RoutesAdmin } from "./RoutesAdmin";

export const AppRoutes = () => {
  const { auth, verifyToken } = useContext(AuthContext);
  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  // Spinner de carga mientras verifica el token
  if (auth.checking) {
    return <Spinner animation="border" role="status" />;
  }

  return (
    <BrowserRouter>
      <Routes>
        {" "}
        <Route
          path="/auth-admin/:id"
          element={
            <RoutesAdmin>
              <AllRoutes />
            </RoutesAdmin>
          }
        />
        <Route
          path="/auth/*"
          element={
            <PublicRoutes isAuthenticated={auth.logged}>
              <AuthRoutes />
            </PublicRoutes>
          }
        />
        <Route
          path="*"
          element={
            <PrivateRoutes isAuthenticated={auth.logged}>
              <AllRoutes />
            </PrivateRoutes>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
